import React from "react";
import { useDispatch } from "react-redux";
import { updateRequest } from "../../../Redux/Slices/requests.slice";
import ArrowIcon from "../../../Common/Svgs/ArrowIcon";

const RequestDetailCTA = ({ request }) => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(
      updateRequest({
        key: "currentRequest",
        value: request,
      }),
    );

    dispatch(
      updateRequest({
        key: "requestDetailsVisible",
        value: true,
      }),
    );
  };

  return (
    <button
      type="button"
      className="w-8 h-6 bg-green-10 rounded-md py-1 px-2"
      onClick={onClick}
    >
      <div className="rotate-90">
        <ArrowIcon className="rotate-90 text-green" />
      </div>
    </button>
  );
};

export default RequestDetailCTA;
